<template>
  <div class="m-conversation">
    <template v-if="conversation.length === 0">
      <div class="empty-tip">暂无聊天记录，您可以在“大厅”发起聊天</div>
    </template>
    <template v-else>
      <div class="item" @click="link(item)" v-for="item in conversation" :key="item.id">
        <div class="avatar-box">
          <el-avatar icon="el-icon-user" :src="item.avatar"></el-avatar>
          <span class="unread" v-if="item.unread">
            {{ item.unread }}
          </span>
        </div>
        <div class="text-box">
          <p class="text-overflow">
            {{ item.company }} - <span style="color: #666">{{ item.name }}</span>
          </p>
          <p style="color: #666" class="text-overflow" v-if="item.lastmsg">{{ "[图片]".repeat(item.lastmsg.imgs.length) }}{{ item.lastmsg.txt }}</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      conversation: state => state.conversation
    })
  },
  methods: {
    link(item) {
      const data = {
        id: item.conversationId,
        company: item.company,
        name: item.name,
        userId: item.id
      };
      this.$store.commit("setPrivateChat", data);
      this.$router.push({
        path: "/conversation",
        query: data
      });
    }
  }
};
</script>
<style lang="scss">
.m-conversation {
  .item {
    cursor: pointer;
    padding: 10px;
    display: flex;
    background-color: white;
    margin-bottom: 10px;
    font-size: 12px;
    .el-avatar {
      margin-right: 10px;
    }
  }
  .text-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .avatar-box {
    position: relative;
    .unread {
      position: absolute;
      right: 0px;
      top: -5px;
    }
  }
  .empty-tip {
    position: absolute;
    width: 100%;
    top: 50%;
    text-align: center;
    color: grey;
    font-size: 14px;
  }
}
</style>
